<template>
  <main v-if="$route.name === 'index'">
    <router-view />
  </main>
  <main v-else>
    <Header />
    <router-view />
    <Footer />
  </main>
</template>

<script>
import Footer from '@/components/Footer/Footer.vue';
import Header from '@/components/Header/Header.vue';

import '@/styles/base.scss';

export default {
  components: { Footer, Header },
};
</script>
